(() => {
  if (customElements.get('toothbrush-interaction')) return;
  customElements.define('toothbrush-interaction', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = [...this.querySelectorAll('[data-category]')];
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.screen = this.querySelector('.tbi__screen-content');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.tabs.forEach(button => { button.disabled = this.pool(button.dataset.category).length === 0; });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-category]');
        if (button && !button.disabled) this.selectCategory(button.dataset.category);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const choice = this.choices.find(item => item.dataset.choice === event.detail.blockId);
        // Editor selection previews this exact block, even when its random weight is zero.
        if (choice) { this.markCategory(choice.dataset.group); this.selectChoice(choice); }
      }, options);
      this.inView = true;
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.syncPlayback();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => {
        this.syncPlayback();
      }, options);
      const first = this.tabs.find(button => !button.disabled);
      if (first) this.selectCategory(first.dataset.category);
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.abort?.abort(); this.abort = null; this.observer?.disconnect();
    }
    syncPlayback() {
      const video = this.screen.querySelector('video');
      if (!video) return;
      if (document.hidden || this.inView === false) video.pause();
      else video.play().catch(() => { /* Browser autoplay restrictions: a category click can retry playback. */ });
    }
    weight(choice) {
      const value = Number.parseFloat(choice.dataset.weight);
      return Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 10;
    }
    pool(category) {
      return this.choices.filter(choice => choice.dataset.group === category && this.weight(choice) > 0);
    }
    pick(category) {
      const pool = this.pool(category);
      if (!pool.length) return null;
      let ticket = Math.random() * pool.reduce((sum, choice) => sum + this.weight(choice), 0);
      for (const choice of pool) {
        ticket -= this.weight(choice);
        if (ticket < 0) return choice;
      }
      return pool[pool.length - 1];
    }
    markCategory(category) {
      this.tabs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
    }
    selectCategory(category) {
      const choice = this.pick(category);
      if (!choice) return;
      this.markCategory(category);
      this.selectChoice(choice);
    }
    selectChoice(choice) {
      const screenLayer = this.screen.parentElement;
      const blend = ['screen', 'lighten', 'normal'].includes(choice.dataset.blend) ? choice.dataset.blend : 'screen';
      const number = (value, fallback, min, max) => {
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? Math.min(max, Math.max(min, parsed)) : fallback;
      };
      screenLayer.style.setProperty('--tbi-blend', blend);
      screenLayer.style.setProperty('--tbi-media-scale', number(choice.dataset.scale, 100, 50, 300) / 100);
      screenLayer.style.setProperty('--tbi-media-x', `${number(choice.dataset.offsetX, 0, -100, 100)}%`);
      screenLayer.style.setProperty('--tbi-media-y', `${number(choice.dataset.offsetY, 0, -100, 100)}%`);
      this.querySelector('.tbi__caption').textContent = choice.dataset.description;
      if (!this.querySelector('.tbi__product-image')) return;
      const template = [...this.querySelectorAll('template[data-media]')].find(item => item.dataset.media === choice.dataset.choice);
      this.screen.querySelector('video')?.pause();
      this.screen.replaceChildren(template.content.cloneNode(true));
      this.screen.classList.remove('is-entering'); void this.screen.offsetWidth; this.screen.classList.add('is-entering');
      const video = this.screen.querySelector('video');
      if (video) {
        video.muted = true; video.playsInline = true; video.loop = true; video.autoplay = true;
        this.syncPlayback();
      }
    }
  });
})();
